import { Redirect } from "@redotech/react-router-util/redirect";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { Navigate } from "react-router-dom";
import {
  MARKETING_ANALYTICS_TABS_URL_PARAM,
  MarketingAnalyticsPage,
} from "../../../analytics/marketing/marketing-analytics";
import { analyticsRoutes } from "../../../analytics/route";
import { overviewRoutes } from "../../../homepage/route";
import { spotlightRoutes } from "../../../spotlights/route";
import { Page } from "../../page";

const ANALYTICS_REPORT_ROUTE = "analytics/reports";
const RETURN_CLAIMS_ROUTE = "analytics/returns-claims";
const TRY_FIRST_ANALYTICS_ROUTE = "analytics/try-first";
const MARKETING_ANALYTICS_ROUTE = "analytics/marketing";

const FULLSCREEN_ROUTES: string[] = ["/spotlights/builder/", "/spotlights/new"];

export function hidePadding(url: string, search: { search: string }) {
  if (FULLSCREEN_ROUTES.some((route) => url.includes(route))) {
    return true;
  }

  if (
    url.includes(MARKETING_ANALYTICS_ROUTE) &&
    new URLSearchParams(search.search).get(
      MARKETING_ANALYTICS_TABS_URL_PARAM,
    ) === MarketingAnalyticsPage.BACK_IN_STOCK
  ) {
    return true;
  }

  const routes = [
    ANALYTICS_REPORT_ROUTE,
    RETURN_CLAIMS_ROUTE,
    TRY_FIRST_ANALYTICS_ROUTE,
  ];
  return routes.some((route) => url.includes(route));
}

export function hideHeader(url: string): boolean {
  return FULLSCREEN_ROUTES.some((route) => url.includes(route));
}

export function hideNavbar(url: string): boolean {
  return FULLSCREEN_ROUTES.some((route) => url.includes(route));
}

export const homeRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Home" },
    async lazy() {
      const { Page } = await import("../../page");
      return {
        element: (
          <Page
            hideHeader={hideHeader}
            hideNavbar={hideNavbar}
            hidePadding={hidePadding}
          />
        ),
      };
    },
    children: [
      {
        index: true,
        element: (
          <Redirect match={/\/home\/?$/} replaceValue="/home/overview" />
        ),
      },
      { path: "claims", element: <Navigate to="/analytics/claims-summary" /> },
      { path: "overview", children: overviewRoutes },
      { path: "spotlights", children: spotlightRoutes },
      { path: "analytics", children: analyticsRoutes },
      {
        path: "*",
        element: <Redirect match={/\/home\/.*/} replaceValue="/home" />,
      },
    ],
  },
];

export const backwardsCompatibleHomeRoutes: PermissionedRouteObject[] = [
  {
    path: "analytics",
    children: [
      {
        element: <Page />,
        children: [
          {
            index: true,
            element: (
              <Redirect match={/analytics/} replaceValue="home/analytics" />
            ),
          },
          {
            path: "*",
            element: (
              <Redirect match={/analytics/} replaceValue="home/analytics" />
            ),
          },
        ],
      },
    ],
  },
  {
    // Redirect old reports/* URLs to analytics/reports/*
    path: "reports",
    children: [
      {
        element: <Page />,
        children: [
          {
            index: true,
            element: (
              <Redirect
                match={/reports/}
                replaceValue="home/analytics/reports"
              />
            ),
          },
          {
            path: "*",
            element: (
              <Redirect
                match={/reports/}
                replaceValue="home/analytics/reports"
              />
            ),
          },
        ],
      },
    ],
  },
  {
    path: "summary",
    children: [
      {
        element: <Page />,
        children: [
          {
            index: true,
            element: <Redirect match={/summary/} replaceValue="home" />,
          },
          {
            path: "*",
            element: <Redirect match={/summary/} replaceValue="home" />,
          },
        ],
      },
    ],
  },
];
